import moment from 'moment';


///use chart name "remind_me" to get all possible charts


//Note that the "mode" key below is useless to the request but signals to the front end what kind of chart to make.
// currently available: "timeseries", "heirarchy", "summary"
const defaultChartRequest = (chartname, slug, type, time_type) => {
	
	
	const now = new moment()
	const today = now.format('YYYY-MM-DD');
	
	const oneYearAgo = now.subtract(1, 'years').format('YYYY-MM-DD');
	const threeMonthsAgo = now.subtract(3, 'months').format('YYYY-MM-DD');
	const oneMonthAgo = now.subtract(1, 'months').format('YYYY-MM-DD');
	const twoWeeksAgo = now.subtract(14, 'days').format('YYYY-MM-DD');
	
	const TIMESERIES = "timeseries"
	const SUMMARY = "calendar"
	const SUMMARY_TIME_PERIODS = ["this_month", "prev_month"]  //"this_month_last_year"
	
	const relations = {
		self: "self",
		children: "children",
		siblings: "siblings"
	}
	
	const charts = {
		timeseries_volume: {
			mode: "timeseries",
			purpose: TIMESERIES,
			parameters: {
				metrics: [
					"volume",
					"battery_volume",
					"tow_volume",
					"not_tow_volume",
				],
				time_type: time_type || "Day",
				to: today,
				from: time_type === 'Hour' ? twoWeeksAgo : oneYearAgo,
			}
		},
		timeseries_std12m: {
			mode: "timeseries",
			purpose: TIMESERIES,
			parameters: {
				metrics: [
					"overall_sat_aaa_mgmt_all_avg",
					"driver_sat_aaa_mgmt_all_avg",
					"response_sat_aaa_mgmt_all_avg",
				],
				time_type: time_type || "Month",
				to: today,
				from: oneYearAgo,
			}
		},
		
		// timeseries_std12m_station: {
		// 	//pass -- above only include sample A
		// },
		
		timeseries_response_time: {
			mode: "timeseries",
			purpose: TIMESERIES,
			parameters: {
				metrics: [
					"early_freq",
					"late_freq",
					"on_time_freq",
				],
				time_type: time_type || "Day",
				to: today,
				from: time_type === 'Hour' ? twoWeeksAgo : oneYearAgo,
			}
		},
		
		summary_volume: {
			mode: "summary",
			purpose: SUMMARY,
			parameters: {
				metrics: [
					"volume",
					"battery_volume",
					"tow_volume",
					"not_tow_volume",
				],
				time_type: SUMMARY_TIME_PERIODS,
				relation: relations.self
			}
			
		},
		
		// summary_kmi: {},
		
		summary_response_time: {
			mode: "summary",
			purpose: TIMESERIES,
			parameters: {
				metrics: [
					"early_freq",
					"late_freq",
					"on_time_freq",
				],
				time_type: SUMMARY_TIME_PERIODS,
				relation: relations.self,
			}
			
		},
		
		summary_std12m: {
			mode: "summary",
			purpose: SUMMARY,
			parameters: {
				metrics: [
					"overall_sat_aaa_mgmt_all_avg",
					"driver_sat_aaa_mgmt_all_avg",
					"response_sat_aaa_mgmt_all_avg",
				],
				time_type: SUMMARY_TIME_PERIODS,
				relation: relations.self
			}
			
		},
		//
		// summary_std12e: {
		// 	mode: "summary",
		// 	purpose: SUMMARY,
		// 	parameters: {
		// 		metrics: [
		// 			"overall_sat_std12_e",
		// 			"response_sat_std12_e",
		// 			"facility_sat_std12_e",
		// 			"kept_informed_sat_std12_e"
		// 		],
		// 		time_type: SUMMARY_TIME_PERIODS,
		// 		relation: relations.self
		// 	}
		// },
		//
		child_ops: {
			mode: "heirarchy",
			purpose: SUMMARY,
			parameters: {
				metrics: [
					"volume",
					"ata_minus_pta_median",
					"on_time_freq",
					"ata_median"
				],
				time_type: SUMMARY_TIME_PERIODS,
				relation: relations.children
			}
		},
		
		
		child_std12m: {
			mode: "heirarchy",
			purpose: SUMMARY,
			parameters: {
				metrics: [
					"overall_sat_aaa_mgmt_all_avg",
					"driver_sat_aaa_mgmt_all_avg",
					"response_sat_aaa_mgmt_all_avg",
				],
				time_type: SUMMARY_TIME_PERIODS,
				relation: relations.children
			}
		},
		
	}
	
	if (chartname.toLowerCase() === "remind_me")  {
		const defaultList = [];
		Object.keys(charts).forEach(d => {
			defaultList.push({name: d, mode: charts[d].mode})
		})
		return defaultList
	}
	
	
	return {slug, type, ...charts[chartname]}
	
}


export default defaultChartRequest;
